import {
  SET_PROC_LIST,
  ADD_PROCESS,
  UPDATE_PROCESS,
  DELETE_PROCESS,
  PROCS_LOADING,
} from '../contants';

const INIT_STATE = {
  procList: [],
  loading: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case PROCS_LOADING:
      return { ...state, loading: action.payload };
    case SET_PROC_LIST:
      return { procList: action.payload };
    case ADD_PROCESS: {
      const procs = [...state.procList];
      procs.push(action.payload);
      return { ...state, procList: procs };
    }
    case UPDATE_PROCESS: {
      const p = action.payload;
      return {
        ...state,
        procList: state.procList.map((v) =>
          v.id === p.id ? { ...v, ...p } : v
        ),
      };
    }
    case DELETE_PROCESS: {
      const procs = [...state.procList];
      const p = action.payload;
      const indx = procs.findIndex((v) => v.id === p.id);
      if (indx >= 0) {
        procs.splice(indx, 1);
      }
      return { ...state, procList: procs };
    }
    default:
      return { ...state };
  }
};
